import { useState } from "react";
import mapImage from "../assets/OPWDD_MAP.png";

export default function Broker() {
  const [openDoc, setOpenDoc] = useState(null);

  const toggleDoc = (doc) => {
    setOpenDoc(openDoc === doc ? null : doc);
  };

  const containerStyle = {
    padding: "60px 20px",
    maxWidth: "1100px",
    margin: "0 auto",
    textAlign: "center"
  };

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "20px",
    alignItems: "start"
  };

  const cardStyle = {
    backgroundColor: "#ffffff",
    borderRadius: "14px",
    padding: "20px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
    textAlign: "left"
  };

  const buttonStyle = {
    display: "inline-block",
    width: "100%",
    padding: "18px 20px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #e8eef2",
    cursor: "pointer",
    color: "#2f6f89",
    fontWeight: "600",
    fontSize: "1.05rem",
    boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
    textAlign: "center"
  };

  const previewContainerStyle = {
    marginTop: "18px",
    backgroundColor: "#fff",
    borderRadius: "14px",
    padding: "16px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.08)"
  };

  const downloadButtonStyle = {
    display: "inline-block",
    marginBottom: "18px",
    padding: "12px 22px",
    backgroundColor: "#2f6f89",
    color: "#ffffff",
    textDecoration: "none",
    borderRadius: "10px",
    fontWeight: "600"
  };

  const iframeStyle = {
    width: "100%",
    height: "700px",
    border: "none",
    borderRadius: "10px"
  };

  const descriptionStyle = {
    fontSize: "0.98rem",
    color: "#444",
    marginTop: "14px",
    lineHeight: "1.6",
    textAlign: "left"
  };

  const noteStyle = {
    fontSize: "0.95rem",
    color: "#555",
    marginBottom: "18px",
    lineHeight: "1.6",
    textAlign: "left"
  };

  return (
    <section style={containerStyle}>
      <h1
        style={{
          fontSize: "2.4rem",
          color: "#2f6f89",
          marginBottom: "40px"
        }}
      >
        🤝 Broker Resources
      </h1>

      <div style={gridStyle}>
        {/* 2026 MASTER TRACKER */}
        <div style={cardStyle}>
          <button style={buttonStyle} onClick={() => toggleDoc("tracker")}>
            📊 2026 Self-Direction Master Tracker
          </button>

          <p style={descriptionStyle}>
            Used to track Self-Direction budgets, service utilization, and
            remaining funds throughout the year. Helps brokers and families
            monitor spending and stay within the approved budget.
          </p>

          {openDoc === "tracker" && (
            <div style={previewContainerStyle}>
              <p style={noteStyle}>
                Preview is not available for this Excel file on the website.
                Please download the file to view and edit it.
              </p>
              <a
                href="/files/SELF_DIRECTION_MASTER_TRACKER.xlsx"
                download
                style={downloadButtonStyle}
              >
                Download 2026 Self-Direction Master Tracker
              </a>
            </div>
          )}
        </div>

        {/* 2025 BUDGET TEMPLATE */}
        <div style={cardStyle}>
          <button style={buttonStyle} onClick={() => toggleDoc("budget")}>
            💰 2025 Self-Direction Budget Template
          </button>

          <p style={descriptionStyle}>
            Excel template used to build or update an OPWDD Self-Direction
            budget. Includes common categories such as staffing, transportation,
            community classes, and other goods and services.
          </p>

          {openDoc === "budget" && (
            <div style={previewContainerStyle}>
              <p style={noteStyle}>
                Preview is not available for this Excel file on the website.
                Please download the file to view and edit it.
              </p>
              <a
                href="/files/2025 SELF-DIRECTION Budget Template.xlsx"
                download
                style={downloadButtonStyle}
              >
                Download 2025 Self-Direction Budget Template
              </a>
            </div>
          )}
        </div>

        {/* BROKER AGREEMENT */}
        <div style={cardStyle}>
          <button style={buttonStyle} onClick={() => toggleDoc("agreement")}>
            📝 2025 Support Broker Agreement
          </button>

          <p style={descriptionStyle}>
            Agreement outlining the role of the Support Broker, services
            provided, and expectations for collaboration with the participant and
            family as part of OPWDD Self-Direction.
          </p>

          {openDoc === "agreement" && (
            <div style={previewContainerStyle}>
              <a
                href="/files/2025 Support Broker Agreement 12JUNE2025.pdf"
                download
                style={downloadButtonStyle}
              >
                Download 2025 Support Broker Agreement
              </a>
              <iframe
                src="/files/2025 Support Broker Agreement 12JUNE2025.pdf#toolbar=0"
                title="2025 Support Broker Agreement"
                style={iframeStyle}
              />
            </div>
          )}
        </div>

        {/* COST NEUTRAL BUDGET AMENDMENT */}
        <div style={cardStyle}>
          <button style={buttonStyle} onClick={() => toggleDoc("cnba")}>
            📄 Cost Neutral Budget Amendment
          </button>

          <p style={descriptionStyle}>
            Used to request updates to an existing Self-Direction budget while
            remaining cost neutral. Typically submitted when reallocating funds
            across categories without increasing the overall approved budget.
          </p>

          {openDoc === "cnba" && (
            <div style={previewContainerStyle}>
              <a
                href="/files/CNBA.pdf"
                download
                style={downloadButtonStyle}
              >
                Download Cost Neutral Budget Amendment
              </a>
              <iframe
                src="/files/CNBA.pdf#toolbar=0"
                title="Cost Neutral Budget Amendment"
                style={iframeStyle}
              />
            </div>
          )}
        </div>
      </div>

      <div
        style={{
          marginTop: "50px",
          display: "flex",
          justifyContent: "center"
        }}
      >
        <img
          src={mapImage}
          alt="OPWDD Regional Coverage Map"
          style={{
            width: "100%",
            maxWidth: "850px",
            borderRadius: "18px",
            boxShadow: "0 10px 25px rgba(0,0,0,0.08)"
          }}
        />
      </div>
    </section>
  );
}